import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  initializeStorefrontAnalytics,
  trackStorefrontPageView,
} from "../Common/storeAnalytics";
import { useGetStoreSettingsPublicQuery } from "../redux/services/store/storeSettingsApi";

const StorefrontAnalytics = () => {
  const location = useLocation();
  const { data: settings } = useGetStoreSettingsPublicQuery();
  const analytics = settings?.analytics;

  useEffect(() => {
    initializeStorefrontAnalytics(analytics);
  }, [analytics]);

  useEffect(() => {
    if (!analytics?.enabled) {
      return;
    }

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    const frameId = window.requestAnimationFrame(() => {
      trackStorefrontPageView({
        analytics,
        pagePath,
        pageLocation: window.location.href,
        pageTitle: document.title || settings?.store?.name || "FionaZiya",
      });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [
    analytics,
    location.pathname,
    location.search,
    location.hash,
    settings?.store?.name,
  ]);

  return null;
};

export default StorefrontAnalytics;
